import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import API from "../api/axios";
import toast from "react-hot-toast";
import { useState, useEffect } from "react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [logoutMessage, setLogoutMessage] = useState("");

useEffect(() => {
  const reason = localStorage.getItem("logout_reason");
  if (reason) {
    localStorage.removeItem("logout_reason");
    setLogoutMessage(reason);
  }
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post("/auth/login", { email, password });
      login(res.data);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div style={s.page}>
    <div style={s.card}>

      {/* Hero image inside card — top section */}
      <div style={s.hero}>
        <img src="/splash_login.png" alt="MartSense" style={s.heroImg} />
        <div style={s.curve} />
      </div>

      {/* Form inside card */}
      <div style={s.formSection}>
        <div style={s.logoRow}>
          <img
            src="/logo.png"
            alt="MartSense"
            style={{ width: "44px", height: "44px",
              objectFit: "contain", marginRight: "-8px" }}
          />
          <span style={{ fontSize: "26px", fontWeight: "800",
            letterSpacing: "-0.5px" }}>
            <span style={{ color: "#21bdae" }}>Mart</span>
            <span style={{ color: "#f6a809" }}>Sense</span>
          </span>
        </div>

        {logoutMessage && (
  <div style={{
    background: "#1a0a0a",
    border: "1px solid #e74c3c",
    borderRadius: "10px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "13px",
    color: "#e74c3c",
    lineHeight: "1.5",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
  }}>
    <span style={{ flexShrink: 0 }}>🔒</span>
    <span>{logoutMessage}</span>
  </div>
)}

        <p style={s.welcome}>Welcome back.</p>
        <h2 style={s.title}>Sign In</h2>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.fieldWrap}>
            <label style={s.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@business.com"
              style={s.input}
              required
            />
          </div>

          <div style={s.fieldWrap}>
            <label style={s.label}>Password</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{ ...s.input, paddingRight: "60px" }}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={s.eyeBtn}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div style={{ textAlign: "right", marginBottom: "24px" }}>
            <span
              onClick={() => navigate("/forgot-password")}
              style={s.forgotLink}
            >
              Forgot Password?
            </span>
          </div>

          <button type="submit" disabled={loading} style={s.submitBtn}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p style={s.registerText}>
          No account yet?{" "}
          <span onClick={() => navigate("/register")} style={s.registerLink}>
            Create one free
          </span>
        </p>
      </div>
    </div>
  </div>
);
}

const s = {
  page: {
    minHeight: "100vh",
    background: "#0a0f0f",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: "440px",
    background: "#0f1a1a",
    borderRadius: "20px",
    overflow: "hidden",
    border: "1px solid #1e3333",
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
  },
  hero: {
    position: "relative",
    height: "220px",
    overflow: "hidden",
  },
  heroImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center top",
    display: "block",
  },
  curve: {
    position: "absolute",
    bottom: "-2px",
    left: 0,
    right: 0,
    height: "50px",
    background: "#0f1a1a",
    borderRadius: "50% 50% 0 0 / 100% 100% 0 0",
  },
  formSection: {
    padding: "8px 28px 36px",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  welcome: {
    fontSize: "15px",
    color: "#5a8a8a",
    margin: "0 0 4px",
    fontWeight: "400",
  },
  title: {
    fontSize: "26px",
    fontWeight: "800",
    color: "#e8f5f5",
    margin: "0 0 24px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  fieldWrap: {
    marginBottom: "16px",
  },
  label: {
    fontSize: "13px",
    color: "#5a8a8a",
    display: "block",
    marginBottom: "6px",
    fontWeight: "500",
  },
  input: {
    width: "100%",
    background: "#162424",
    border: "1px solid #1e3333",
    borderRadius: "10px",
    padding: "14px 16px",
    color: "#e8f5f5",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
  },
  eyeBtn: {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600",
    color: "#21bdae",
    padding: "0",
  },
  forgotLink: {
    fontSize: "13px",
    color: "#f6a809",
    cursor: "pointer",
    fontWeight: "600",
  },
  submitBtn: {
    background: "linear-gradient(135deg, #21bdae, #1a9e92)",
    color: "#0a0f0f",
    border: "none",
    borderRadius: "12px",
    padding: "16px",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    width: "100%",
    marginBottom: "20px",
  },
  registerText: {
    textAlign: "center",
    fontSize: "14px",
    color: "#5a8a8a",
  },
  registerLink: {
    color: "#21bdae",
    fontWeight: "700",
    cursor: "pointer",
  },
};